import { REWARDS_DISCOUNT_TYPES } from "@apps/rewards/constants/rewardsDiscountTypes";
import {
    assign,
    enums,
    literal,
    nullable,
    number,
    object,
    string,
} from "superstruct";

export const RewardsDiscountRewardSchema = object({
    type: literal("discount"),
    discountType: enums(Object.values(REWARDS_DISCOUNT_TYPES)),
    discountValue: nullable(number()),
});

export const RewardsDiscountExtraInfoRewardSchema = assign(
    RewardsDiscountRewardSchema,
    object({
        expirationInDays: nullable(number()),
        minimumOrderAmount: nullable(number()),
    })
);

export const RewardsDiscountCodeRewardSchema = assign(
    RewardsDiscountRewardSchema,
    object({
        discountCode: string(),
    })
);
